var _style, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#83858c;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#83858c;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.3,23.6c-0.1,0-0.2,0-0.2,0c-1.2-0.1-2.2-1.2-2.2-2.5v-8.7h-4c-0.1,0-0.2-0.1-0.3-0.2 c-0.3-0.4-0.5-0.9-0.5-1.4c0-1.3,1.1-2.4,2.4-2.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.5,8.4h9.6c1.3,0,2.4,1.1,2.4,2.4v8.8h2.6c0.1,0,0.2,0.1,0.3,0.2c0.3,0.4,0.5,0.9,0.5,1.4 c0,1.3-1.1,2.4-2.4,2.4h-8.2c0,0,0,0,0,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.5,8.4c1.3,0,2.4,1.1,2.4,2.4c0,0.5,0,0.8,0,1.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.1,19.6c0.1,0,0.2,0.1,0.3,0.2c0.3,0.4,0.5,0.9,0.5,1.4c0,1.3-1.1,2.4-2.4,2.4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 16.2,
    y1: 19.6,
    x2: 21.6,
    y2: 19.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 14.3,
    y1: 11.8,
    x2: 19.2,
    y2: 11.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 14.3,
    y1: 14.4,
    x2: 19.2,
    y2: 14.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 14.3,
    y1: 16.9,
    x2: 19.2,
    y2: 16.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuests);
export default __webpack_public_path__ + "static/media/quests.0d8d8e65f48cb45fef905e46d1c6add2.svg";
export { ForwardRef as ReactComponent };